import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class MarksService {

  constructor(private http: HttpClient) {}

  get(){
    return this.http.get(environment.apiUrl + 'marks');
  }

  updatePositions(items: any[]) {
    return this.http.post(environment.apiUrl +  'admin/mark/update-positions', items);
  }

  add(data: any) {
    return this.http.post(environment.apiUrl +  'admin/mark/add', data);
  }

  update(data: any) {
    return this.http.post(environment.apiUrl +  'admin/mark/update' ,data);
  }

  delete(id: number) {
    return this.http.delete(environment.apiUrl +  `admin/mark/destroy/${id}`);
  }

}
